import Button from '@/components/ui/Button'
import type { DialogProps } from '@/components/ui/Dialog'
import Dialog from '@/components/ui/Dialog'
import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import { CgCloseO } from 'react-icons/cg'
import { HiOutlineExclamation } from 'react-icons/hi'
import { Avatar } from '../ui'

interface ConfirmDialogProps extends DialogProps {
   onCancel?: () => void
   error: AxiosError
   message?: string
}

const ErrorDialog = (props: ConfirmDialogProps) => {
   const { t } = useTranslation(undefined, { keyPrefix: 'components.shared.errorDialog' })

   const { children, onCancel, error, ...rest } = props

   const handleCancel = () => {
      onCancel?.()
   }

   const getErrors = (errors: any) => {
      const keys = Object.keys(errors)

      return keys.map((key) => {
         const keyedErrors = errors[key]

         return keyedErrors.map((keyedError: any) => {
            return (
               <div className="flex align-center">
                  <span className="mr-2.5 flex  text-sm text-red-600">
                     <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_980_24913)">
                           <path
                              d="M10 0.5625C4.78125 0.5625 0.5625 4.78125 0.5625 10C0.5625 15.2188 4.78125 19.4688 10 19.4688C15.2188 19.4688 19.4688 15.2188 19.4688 10C19.4688 4.78125 15.2188 0.5625 10 0.5625ZM10 18.0625C5.5625 18.0625 1.96875 14.4375 1.96875 10C1.96875 5.5625 5.5625 1.96875 10 1.96875C14.4375 1.96875 18.0625 5.59375 18.0625 10.0312C18.0625 14.4375 14.4375 18.0625 10 18.0625Z"
                              fill="currentColor"
                           />
                           <path
                              d="M12.875 7.09375C12.5938 6.8125 12.1563 6.8125 11.875 7.09375L10 9L8.09375 7.09375C7.8125 6.8125 7.375 6.8125 7.09375 7.09375C6.8125 7.375 6.8125 7.8125 7.09375 8.09375L9 10L7.09375 11.9062C6.8125 12.1875 6.8125 12.625 7.09375 12.9062C7.21875 13.0312 7.40625 13.125 7.59375 13.125C7.78125 13.125 7.96875 13.0625 8.09375 12.9062L10 11L11.9062 12.9062C12.0312 13.0312 12.2188 13.125 12.4063 13.125C12.5938 13.125 12.7812 13.0625 12.9062 12.9062C13.1875 12.625 13.1875 12.1875 12.9062 11.9062L11 10L12.9062 8.09375C13.1562 7.8125 13.1563 7.375 12.875 7.09375Z"
                              fill="currentColor"
                           />
                        </g>
                        <defs>
                           <clipPath id="clip0_980_24913">
                              <rect width={20} height={20} fill="white" />
                           </clipPath>
                        </defs>
                     </svg>
                  </span>
                  <div className="w-full">
                     <span className="schema-detail-text mr-1">{keyedError}</span>
                     <span>
                        <b>{key}</b>
                     </span>
                  </div>
               </div>
            )
         })
      })
   }

   const getArrayErrors = (errors: any) => {
      return errors.map((keyedError: any) => {
         return (
            <div className="flex align-center">
               <span className="mr-2.5 flex  text-sm text-red-600">
                  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <g clipPath="url(#clip0_980_24913)">
                        <path
                           d="M10 0.5625C4.78125 0.5625 0.5625 4.78125 0.5625 10C0.5625 15.2188 4.78125 19.4688 10 19.4688C15.2188 19.4688 19.4688 15.2188 19.4688 10C19.4688 4.78125 15.2188 0.5625 10 0.5625ZM10 18.0625C5.5625 18.0625 1.96875 14.4375 1.96875 10C1.96875 5.5625 5.5625 1.96875 10 1.96875C14.4375 1.96875 18.0625 5.59375 18.0625 10.0312C18.0625 14.4375 14.4375 18.0625 10 18.0625Z"
                           fill="currentColor"
                        />
                        <path
                           d="M12.875 7.09375C12.5938 6.8125 12.1563 6.8125 11.875 7.09375L10 9L8.09375 7.09375C7.8125 6.8125 7.375 6.8125 7.09375 7.09375C6.8125 7.375 6.8125 7.8125 7.09375 8.09375L9 10L7.09375 11.9062C6.8125 12.1875 6.8125 12.625 7.09375 12.9062C7.21875 13.0312 7.40625 13.125 7.59375 13.125C7.78125 13.125 7.96875 13.0625 8.09375 12.9062L10 11L11.9062 12.9062C12.0312 13.0312 12.2188 13.125 12.4063 13.125C12.5938 13.125 12.7812 13.0625 12.9062 12.9062C13.1875 12.625 13.1875 12.1875 12.9062 11.9062L11 10L12.9062 8.09375C13.1562 7.8125 13.1563 7.375 12.875 7.09375Z"
                           fill="currentColor"
                        />
                     </g>
                     <defs>
                        <clipPath id="clip0_980_24913">
                           <rect width={20} height={20} fill="white" />
                        </clipPath>
                     </defs>
                  </svg>
               </span>
               <div className="w-full">
                  <span className="schema-detail-text mr-1">{keyedError.code}</span>
                  <span>
                     <b>{keyedError.description}</b>
                  </span>
               </div>
            </div>
         )
      })
   }

   return (
      <Dialog
         {...rest}
         shouldCloseOnEsc={true}
         shouldCloseOnOverlayClick={true}
         onRequestClose={handleCancel}
         style={{ content: { zIndex: 999999 }, overlay: { zIndex: 999999999 } }}
      >
         <div className=" pb-6 pt-2 flex items-center">
            <div>
               <Avatar className="text-red-600 bg-red-100 dark:text-red-100" shape="circle">
                  <span className="text-2xl">
                     <HiOutlineExclamation />
                  </span>
               </Avatar>
            </div>
            <div className="ml-4 rtl:mr-4">
               <h5 className="mb-2">{t('title')}</h5>
               {children}
            </div>
         </div>
         {props.message && <div>{props.message}</div>}
         {props.message === undefined && (
            <>
               <p>
                  {error.response?.status !== 402 && (
                     <div className={'bg-red-100 px-4 py-3 rounded-md font-semibold text-red-600 dark:text-red-900 mb-4'}>
                        Talebinizde bir hata mevcut. Detayları aşağıda paylaşılmıştır.
                     </div>
                  )}

                  {error.response?.status === 402 && (
                     <div className={'bg-red-100 px-4 py-3 rounded-md font-semibold text-red-600 dark:text-red-900 mb-4'}>
                        Lisans Hatası : {(error.response.data as any).licenseType}
                     </div>
                  )}

                  {(error.response?.data as any)?.errors &&
                     !Array.isArray((error.response?.data as any)?.errors) &&
                     getErrors((error.response?.data as any)?.errors)}

                  {(error.response?.data as any)?.errors &&
                     Array.isArray((error.response?.data as any)?.errors) &&
                     getArrayErrors((error.response?.data as any)?.errors)}
               </p>
            </>
         )}

         <div className="text-right mt-6">
            <Button className="ltr:mr-2 rtl:ml-2" variant="twoTone" color="red-600" onClick={handleCancel} icon={<CgCloseO />}>
               {t('cancelButton')}
            </Button>
         </div>
      </Dialog>
   )
}

export default ErrorDialog
